import { createReducer } from 'platform/shared/health-apps';
import { CHAMPVA_ENROLLMENT_STATUS_ACTIONS } from '../actions';

const { STARTED, SUCCEEDED, FAILED } = CHAMPVA_ENROLLMENT_STATUS_ACTIONS;

export const CHAMPVA_ENROLLMENT_STATUS_INIT_STATE = {
  enrollmentStatus: null,
  loading: false,
};

export const champvaEnrollmentStatusReducer = createReducer(
  CHAMPVA_ENROLLMENT_STATUS_INIT_STATE,
  {
    [STARTED]: () => ({
      ...CHAMPVA_ENROLLMENT_STATUS_INIT_STATE,
      loading: true,
    }),
    [SUCCEEDED]: (state, { response }) => ({
      ...state,
      enrollmentStatus: response.enrollmentStatus ?? null,
      loading: false,
    }),
    [FAILED]: state => ({ ...state, loading: false }),
  },
);
